import { render, staticRenderFns } from "./OnboardingPostCreate.vue?vue&type=template&id=2dbb2d3b&scoped=true&lang=pug&"
import script from "./OnboardingPostCreate.vue?vue&type=script&lang=js&"
export * from "./OnboardingPostCreate.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPostCreate.vue?vue&type=style&index=0&id=2dbb2d3b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb2d3b",
  null
  
)

export default component.exports